import { axiosApi } from "../../interceptors/axios";
import { Result } from "../../types/Result";
import { UserProfessionInfo } from "./type";

export const getUserProfessionInfo = (userId: string) =>
  axiosApi.get<Result<UserProfessionInfo>>(
    `/api/users/${encodeURIComponent(userId)}/profession`,
  );

export const changeUserProfession = (userId: string, professionCode: string) =>
  axiosApi.put<Result<UserProfessionInfo>>(
    `/api/users/${encodeURIComponent(userId)}/profession`,
    {
      professionCode,
    },
  );
